module.exports = __webpack_public_path__ + "static/img/lm-intro-h5-2.5513934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lm-intro-h5-2.png
// module id = qHLW
// module chunks = 0